import { useEffect } from 'react';
export const useNationalityField = ({
    disableNationalityByCountry,
    formActions,
    getReferenceCodeByCountry,
    options,
    optionsActions,
    userProfile,
}) => {
    const { documentType, isAlreadyClient } = userProfile;

    useEffect(() => {
        if (options.get('countries').size === 0) {
            optionsActions.getProvinces();
            optionsActions.getCountries();
        }

        const shouldShowNationalityField = isAlreadyClient;
        formActions.change('userProfile.shouldShowNationalityField', shouldShowNationalityField);

        if (disableNationalityByCountry(documentType) && shouldShowNationalityField) {
            formActions.change('userProfile.nationality', getReferenceCodeByCountry().toUpperCase());
        }
        window.scrollTo(0, 0);
    }, []);
};
